module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/preface"
    }
  }, [_c('b', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledgement"
    }
  }, [_c('b', [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01"
    }
  }, [_c('b', [_vm._v("Chapter 1. Edisto Before Colonization")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h1"
    }
  }, [_vm._v("The Land.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h2"
    }
  }, [_vm._v("An Erosion-Remnant Island.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h3"
    }
  }, [_vm._v("Edisto’s Barrier Islands.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h4"
    }
  }, [_vm._v("Edisto’s Marshes.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h5"
    }
  }, [_vm._v("A Major Black-water River.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h6"
    }
  }, [_vm._v("Edisto’s Climate and Landscape.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h7"
    }
  }, [_vm._v("Edisto’s Animal and Bird Life.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h8"
    }
  }, [_vm._v("The Earliest Humans in South Carolina.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h9"
    }
  }, [_vm._v("The Indians of First European Contact.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h10"
    }
  }, [_vm._v("How the Edisto Indians Lived.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h11"
    }
  }, [_vm._v("A Spanish Missionary among the Edisto in 1570.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h12"
    }
  }, [_vm._v("English Explorers Visit Edisto in the 1660s.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h13"
    }
  }, [_vm._v("The Decline of the Edisto Indians after 1670.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#h14"
    }
  }, [_vm._v("The Edisto Indians Today.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 2. Edisto’s Europeans")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Carolina Colony.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Earliest Settlers on Edisto Island.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul Grimball, the Man and the Politician.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Second Wave of Settlers on Edisto Island.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hamilton Family on Edisto.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edisto’s Planter Class in the 1700s.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turmoil in the 1700s: Human Conflicts and Natural Disasters.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edisto Island in the Revolutionary War.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 3. Edisto’s Africans")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Slave Trading in Charleston, 1670–1807.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ethnic Origins of the Africans Brought to Carolina.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("African Slaves on Rice Plantations: A Unique Case.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Slave Population on Edisto in the 1700s.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Illegal Trade in African Captives after 1807.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Edisto Family from “Angola.”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 4. Edisto’s Early Economy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lumber, Corn and Cattle.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rice.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Indigo.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Advent of Sea-island Cotton.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Growing Sea-island Cotton.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preparing Sea-island Cotton for Market.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sea-island Cotton Exports.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 5. Plantation Slavery on Edisto")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Slave Population on Edisto.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edisto Plantation Social Structure and Management.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sea Island Task System.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Food, Clothing and Housing for Slaves.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Health and Medical Care of Slaves on Edisto.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religion among Slaves on Edisto.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gullah Language and Culture.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Was Slavery on Edisto Island “Different”?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resistance by Slaves on Edisto Island.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 6. Edisto’s “Golden Age”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sea-island Cotton Was King.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edisto’s Building Boom.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edingsville Beach.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The 1850s Mapping Project.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Presbyterian Church on Edisto Island.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trinity Episcopal Church.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old First Baptist Church.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Early Methodism on Edisto Island.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edisto’s Tiny Middle Class.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 7. Edisto’s Plantation Aristocracy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Southeast Corner of Edisto Island.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edingsville to Holmes’s Store.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Southwest Corner of Edisto Island.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("St. Pierre’s Creek.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("North Edisto.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Center of Island.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bailey’s Island and Scanawah Island.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Northwest Corner of Edisto Island.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Little Edisto.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jehossee Island.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/postscript",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Postscript")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Selected Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0